// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('.main-content');
  }

  @on({ event: 'click', selector: '.copy-button' })
  onClickCopyButton() {
    $('.copied-message-bar').removeClass('d-none');
    setTimeout(() => {
      $('.copied-message-bar').addClass('d-none');
    }, 3000);
  }

  @on({ event: 'click', selector: '.message-close' })
  onClickMassageCloseButton() {
    $('.copied-message-bar').addClass('d-none');
  }
}
